import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinarySymptomUpdateAction from './veterinarySymptomUpdate.action.json' with { type: 'json' }
import { veterinarySymptomObject } from '../veterinarySymptomObject'

const veterinarySymptomUpdateDefinition = defineAction({
  ...veterinarySymptomUpdateAction,

  input: veterinarySymptomObject.partial().required({ id: true }),
  output: z.object({}),
})

export default veterinarySymptomUpdateDefinition
